// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Chip,
  Grid,
} from '@material-ui/core';

/* -----------------Props--------------- */
type Props = {
  label: string,
  type?: string
};

/* -----------------Component--------------- */
const Tag = (props: Props) => {
  const {
    label,
    type,
    ...rest
  } = props;
  const chipLabel = type ? `${type}: ${label}` : label;
  // TODO: The <Grid> should be outside of this component
  // Violates rule about components not determine their parent layout
  return (
    <Grid item key={label}>
      <Chip
        {...rest}
        variant="outlined"
        color="secondary"
        size="small"
        label={chipLabel}
      />
    </Grid>
  );
};

export default Tag;
